import { FC } from 'react';
import dayjs from 'dayjs';
import { DriverData } from '../../../types/common';

import './index.css';

interface DriverInfoProps {
  data: DriverData | DriverData[];
  isToday: boolean;
}

const totalSeconds = 24 * 60 * 60;

const getBarStyle = (start: string, end: string, color: string, borderColor: string, isToday: boolean) => {
  const s = dayjs(start);
  const e = dayjs(end);
  const getDate = dayjs(start).format('YYYY-MM-DD');
  const now = dayjs().format('HH:mm:ss');
  const currentTime = dayjs(`${getDate} ${now}`);
  
  const startSec = s.hour() * 3600 + s.minute() * 60 + s.second();
  let endSec = e.hour() * 3600 + e.minute() * 60 + e.second();
  
  // 如果是今天，則使用當前時間作為總時間
  const totalTime = isToday 
    ? currentTime.hour() * 3600 + currentTime.minute() * 60 + currentTime.second()
    : totalSeconds;
  
  // 如果是今天，且結束時間超過當前時間，則使用結束時間
  if (isToday && e.isAfter(currentTime)) {
    endSec = currentTime.hour() * 3600 + currentTime.minute() * 60 + currentTime.second();
  }
  
  const left = (startSec / totalTime) * 100;
  const width = ((endSec - startSec) / totalTime) * 100;
  return {
    left: `${left}%`,
    width: `${width}%`,
    backgroundColor: color,
    border: `2px solid ${borderColor}`,
  };
};

const DriverLine: FC<DriverInfoProps> = ({ data, isToday }) => {
  const drivers: DriverData[] = Array.isArray(data) ? data : [data];

  // 攤平成一個 bar 陣列
  const allBars: {
    start: string;
    end: string;
    color: string;
    borderColor: string;
    name: string;
    cardId: string;
  }[] = [];
  
  drivers.forEach(driver => {
    const driveHours = Array.isArray(driver.driveHours) ? driver.driveHours : [driver.driveHours];
    driveHours.forEach(period => {
      allBars.push({
        start: period.start,
        end: period.end,
        color: driver.color,
        borderColor: driver.borderColor,
        name: driver.name,
        cardId: driver.cardId,
      });
    });
  });


  return (
    <div className="driver-line">
      {allBars.map((bar, idx) => (
        <div
          key={bar.cardId + bar.start + bar.end}
          style={getBarStyle(bar.start, bar.end, bar.color, bar.borderColor, isToday)}
          data-desc={`${bar.name}｜${bar.start} ~ ${bar.end}`}
          className="driver-line__bar"
        >
          <div className="driver-line__bar-title">{bar.name}</div>
        </div>
      ))}
    </div>
  );
};


export default DriverLine;